import {
  ɵComponentType as ComponentType,
  ɵDirectiveType as DirectiveType,
  ɵComponentDef as ComponentDef,
  ɵDirectiveDef as DirectiveDef
} from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { Subject } from 'rxjs/internal/Subject';

export interface OnDestroyLike {
  ngOnDestroy(): void;
  [key: string]: any;
}

export function componentDestroyed(component: OnDestroyLike): Observable<void> {
  if (!(component as any).__decoratorApplied) {
    throw new Error('Use @UntilDestroy decorator in class');
  }

  if (!(component as any).__componentDestroyed$) {
    (component as any).__componentDestroyed$ = new Subject();
  }
  return (component as any).__componentDestroyed$;
}

export function UntilDestroy(cmpType: any) {
  const original = cmpType.prototype.ngOnDestroy;
  cmpType.prototype.__decoratorApplied = true;
  cmpType.prototype.ngOnDestroy = function(this: any) {
    original.call(this);
    if (this.__componentDestroyed$) {
      this.__componentDestroyed$.next();
      this.__componentDestroyed$.complete();
      delete this.__componentDestroyed$;
    }
  };
}

function getDef<T>(
  type: DirectiveType<T> | ComponentType<T>
): DirectiveDef<T> | ComponentDef<T> | unknown {
  return (type as ComponentType<T>).ɵcmp || (type as DirectiveType<T>).ɵdir;
}
